import * as React from 'react'

function SvgDashBikes(props) {
  return (
    <svg
      width="2.2rem"
      height="2.2rem"
      viewBox="0 0 32 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={32} height={31} rx={10} fill="#fff" />
      <path
        d="M21.744 16.29c-.43 0-.894.104-1.288.282l-.478-.713a4.565 4.565 0 012.29-.618c.29 0 .524-.234.524-.524v-1.048A3.673 3.673 0 0019.125 10h-1.048a.524.524 0 100 1.048h.524v1.048h-1.572a.524.524 0 00-.436.234l-.544.815h-4.4l-.263-.395a1.464 1.464 0 00-1.221-.654h-2.64A.524.524 0 007 12.62a2.625 2.625 0 002.33 2.605l.715 1.074A3.143 3.143 0 007 19.434a3.148 3.148 0 003.145 3.144 3.15 3.15 0 002.957-2.096h3.152c.697 0 1.303-.497 1.439-1.18l.074-.371a4.561 4.561 0 011.376-2.436l.444.662a3.154 3.154 0 00-.987 2.277c0 1.692 1.422 3.144 3.144 3.144a3.148 3.148 0 003.145-3.144 3.148 3.148 0 00-3.145-3.145zm-11.6 4.188h1.812a2.106 2.106 0 01-1.811 1.052 2.098 2.098 0 01-2.097-2.096c0-1.157.94-2.097 2.097-2.097.232 0 .457.046.673.12l.183.275c.273.41.73.653 1.22.653h-2.076c-.58 0-1.049.47-1.049 1.049 0 .578.47 1.044 1.049 1.044zm11.6 1.052c-1.135 0-2.096-.954-2.096-2.096 0-.485.17-.968.538-1.384l1.123 1.675a.524.524 0 10.87-.583l-1.123-1.676c.253-.088.421-.129.688-.129 1.157 0 2.097.94 2.097 2.097 0 1.156-.94 2.096-2.097 2.096z"
        fill="#FF7B0D"
      />
    </svg>
  )
}

export default SvgDashBikes
